// extracted by mini-css-extract-plugin
export default {"cardContainer":"ContractPage_cardContainer__1rYgb"};